/*
 * @Author: 吴紫阳 764401855@qq.com
 * @Date: 2022-09-22 15:19:58
 * @LastEditors: 吴紫阳 764401855@qq.com
 * @LastEditTime: 2022-10-10 16:46:30
 * @FilePath: \pit-bimwin-react-ui\src\components\PitBusiness\PitProperties.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, {
  FC,
  useEffect,
  useMemo,
  useState,
  // CSSProperties,
  // memo,
  // useCallback,
  // useRef,
  // useEffect,
} from 'react';
interface bimwinProps {
  isDebug?: boolean;
}
interface PitComponentDetailsProps {
  bimwin?: bimwinProps;
  propertiesData: any;
}
const PitComponentDetails: FC<PitComponentDetailsProps> = ({
  bimwin,
  propertiesData,
}) => {
  let [propertiesDataList, setpropertiesDataList] = useState<any>([]);
  let [optionActive] = useState('components');
  let [active, setactive] = useState(-1);
  let optionTips = useMemo(() => {
    if (optionActive === 'components') {
      return '请选择一个构件，以查看对应属性';
    }
    if (optionActive === 'material') {
      return '暂无对应材质属性';
    }
    return '';
  }, []);
  useEffect(() => {
    propertiesData && initProetData([...(propertiesData || [])]);
  }, [propertiesData]);
  const initProetData = (value: any) => {
    setpropertiesDataList(value);
  };
  const propertiesDataListFn = (index: number) => {
    setactive(index);
    setpropertiesDataList((pre: any) => {
      const obj = pre;
      obj[index].show = !obj[index].show;
      return [...obj];
    });
  };
  const propertiesDataListNode = propertiesDataList.map(
    (item: any, index: number) => {
      const ItemProps = Object.keys(item.Props || {}).map(
        (items: string, indexs: number) => {
          return (
            <div className="pit-group-content" key={indexs}>
              <div className="pit-key">
                <p>{items}</p>
              </div>
              <div className="pit-value">
                <p>{item.Props[items]}</p>
              </div>
            </div>
          );
        }
      );
      return (
        <div
          className={`pit-group ${item.show ? 'pit-collapse' : ''}`}
          key={index}
        >
          <div
            className={`pit-group-title ${active === index ? 'active' : ''}`}
            onClick={() => propertiesDataListFn(index)}
          >
            <div className="pointer">
              <i className="pit-icon mr-5"></i>
              {item.Name}
            </div>
          </div>
          {ItemProps}
        </div>
      );
    }
  );
  return (
    <div style={{ width: '100%' }} className="pit-component-details">
      <span
        style={{
          userSelect: 'text',
          display: bimwin && bimwin.isDebug ? '' : 'none',
        }}
      >
        {/* {propertiesData} */}
      </span>

      {!propertiesDataList.length ? (
        <div className="pit-panel-tips">{optionTips}</div>
      ) : (
        <div className="pit-panel-container pit-scroll-bar">
          <div className="pit-table">{propertiesDataListNode}</div>
        </div>
      )}
    </div>
  );
};
export default PitComponentDetails;
